export const ESCALATION_REASONS = [
  {
    id: 'safety',
    label: 'Safety Concern',
    subreasons: ['Guest injury', 'Property damage', 'Fire hazard', 'Structural issue', 'Other safety'],
  },
  {
    id: 'service_failure',
    label: 'Service Failure',
    subreasons: ['Vendor no-show', 'Wrong items delivered', 'Incomplete service', 'Quality issue'],
  },
  {
    id: 'guest_complaint',
    label: 'Guest Complaint',
    subreasons: ['Unresolved issue', 'Repeated complaint', 'Refund request', 'Threatening behavior'],
  },
  {
    id: 'payment',
    label: 'Payment Issue',
    subreasons: ['Failed charge', 'Disputed charge', 'Refund needed', 'Billing error'],
  },
  {
    id: 'property',
    label: 'Property Issue',
    subreasons: ['Access problem', 'Maintenance emergency', 'Neighbor complaint', 'Noise violation'],
  },
  {
    id: 'other',
    label: 'Other',
    subreasons: ['Requires manager approval', 'Policy exception', 'Custom request'],
  },
];

export const ESCALATION_CHECKLIST = [
  'Attempted to resolve with guest directly',
  'Documented all communication',
  'Checked existing policies for resolution',
  'Notified property manager if applicable',
  'Attached relevant evidence or screenshots',
];
